<template>
  <LayoutSite>
    <Formulario titulo="Meu Perfil">
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-text-field label="Nome" autofocus v-model="usuario.name" disabled></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field label="Login" v-model="usuario.email" disabled></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                label="Senha"
                v-model="usuario.password"
                :type="showpass ? 'text' : 'password'"
                :append-icon="showpass ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showpass = !showpass"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                label="Confirmação Senha"
                v-model="usuario.password_confirmation"
                :type="showconf ? 'text' : 'password'"
                :append-icon="showconf ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showconf = !showconf"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field label="Meta" v-model="usuario.meta" disabled></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-autocomplete
                label="Perfil"
                v-model="usuario.perfil_id"
                :items="perfis"
                item-text="nome"
                item-value="id"
                disabled
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-alert
            dense
            outlined
            type="error"
            v-for="(erro, index) of erros"
            :key="index"
          >{{erro[0]}}</v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed color="primary" @click="salvar()">SALVAR</v-btn>
        </v-card-actions>
      
    </Formulario>
  </LayoutSite>
</template>

<script>
import LayoutSite from "@/components/layout/LayoutSite";
import Formulario from "@/components/Form";

export default {
  components: {
    LayoutSite,
    Formulario
  },
  data() {
    return {
      erros: [],
      perfis: [],
      showpass: false,
      showconf: false,
      usuario: {
        id: 0,
        name: "",
        password: "",
        password_confirmation: "",
        email: "",
        meta: 0,
        perfil_id: 0
      }
    };
  },
  created: function() {
    let usuarioaux = this.$store.getters.getUsuario;
    if (usuarioaux) {
      this.usuario = usuarioaux;
    }
    this.getData();
  },
  methods: {
    getData() {
      this.$http
        .get(this.$urlAPI + "/perfil", {
          headers: { authorization: "Bearer " + this.$store.getters.getToken }
        })
        .then(response => (this.perfis = response.data));
    },
    salvar() {
      console.log('entrou?');
      console.log(this.$urlAPI);

      this.$http
        .post(this.$urlAPI + "/resetpassword", this.usuario, {
          headers: { authorization: "Bearer " + this.$store.getters.getToken }
        })
        .then(response => {
          console.log(response.data);
          if (response.data.status) {
            this.$router.push("/");
          } else {
            this.erros = null;
            this.erros = response.data.erros;
          }
        })
        .catch(e => {
          this.erros = e.response.data.erros;
        });
    }
  }
};
</script>
